






































import Vue from 'vue'
import Component from 'vue-class-component'
import Locale from '@/modules/i18n/model/Locale'
import WorldLocale from '@/modules/i18n/model/WorldLocale'
import { Getter } from 'vuex-class/lib/bindings'
import { I18nError } from '@/modules/i18n/api'
import { VForm } from '@/types'
import KeyValuePair from '@/modules/core/support/KeyValuePair'
import { notify } from '@/modules/core/notification'

/**
 * Detalle de la configuración regional
 */
@Component
export default class LocaleDetailComponent extends Vue {
    @Getter('i18n/simpleLocaleNames')
    public items: WorldLocale[]

    public errorMessages: string[] = []
    public loading = false
    public selectedLocale = new WorldLocale('', '')
    public $refs: {
        form: VForm,
    }

    public localeSelectRules = [
        (v: KeyValuePair) => (v.identifier || '').length > 0  || 'El identificador es obligatorio',
    ];

    /**
     * Registra el localismo seleccionado
     */
    public async onSave (): Promise<void> {
        if (!this.$refs.form.validate()) {
            return
        }

        this.loading = true
        const newLocale = new Locale(0, this.selectedLocale.identifier)

        // Llamada a la acción para crear el localismo en Artisan y registrarlo
        // en el estado
        try {
            await this.$store.dispatch('i18n/createLocale', {
                locale: newLocale,
            })
        } catch (error) {
            if (error instanceof I18nError) {
                this.errorMessages.push(error.message)
                this.loading = false
            }

            throw error
        }

        this.$emit('save')
        this.clearForm()
        this.loading = false

        notify(`El idioma ${newLocale.identifier} se ha registrado correctamente`)
    }

    /**
     * Reseta el formulario
     */
    public clearForm (): void {
        this.$refs.form.reset()

        // Necesario porque form.reset() define a null el valor selectedLocale
        this.selectedLocale = new WorldLocale('', '')
    }
}
